/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Error_EnrollmentInputs */

const en_player_error_enrollment = /** @type {(inputs: Player_Error_EnrollmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error loading enrollment`)
};

const ja_player_error_enrollment = /** @type {(inputs: Player_Error_EnrollmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登録情報の読み込みエラー`)
};

const fr_player_error_enrollment = /** @type {(inputs: Player_Error_EnrollmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors du chargement de l'inscription`)
};

const de_player_error_enrollment = /** @type {(inputs: Player_Error_EnrollmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Laden der Einschreibung`)
};

/**
* | output |
* | --- |
* | "Error loading enrollment" |
*
* @param {Player_Error_EnrollmentInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const player_error_enrollment = /** @type {((inputs?: Player_Error_EnrollmentInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Error_EnrollmentInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_player_error_enrollment(inputs)
	if (locale === "ja") return ja_player_error_enrollment(inputs)
	if (locale === "fr") return fr_player_error_enrollment(inputs)
	return de_player_error_enrollment(inputs)
});